import React, { useState, useEffect } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
//import "./index.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
const LanguageInputs = [
  {
    name: "language",
    label: "Language",
    type: "text",
    required: true,
     validation: { required: true,
      pattern: /^[A-Za-z0-9-\s]*$/,
      message: "Special symbols are not allowed",
     },
    gridClass: "col-lg-4",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "status",
    label: "Status",
    type: "dropdown",
    required: true,
    options: [
      { label: "Active", value: "Active" },
      { label: "Inactive", value: "Inactive" },
    ],
    gridClass: "col-lg-4",
  },
];

const EditLanguage = () => {
  const [formData, setFormData] = useState({
    language: "",
    description: "",
    status: "", 
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const authToken = localStorage.getItem("authToken");
  const navigate = useNavigate();
  const location=useLocation()
  const data = location?.state?.data

  useEffect(() => {
   
    const fetchLanguageDetails = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`/language/edit/${data.language_id}`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        const { language_name, language_desc, status } = response.data.data;
        setFormData({
          language: language_name,
          description: language_desc,
          status: status === 1 ? "Active" : "Inactive",
        });
      } catch (error) {
        console.error("Error fetching language details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLanguageDetails();
  }, [authToken]);

  

const handleFormSubmit = async () => {
  const errors = {};
  let isValid = true;

  LanguageInputs.forEach((field) => {
    if (field.required && !formData[field.name]) {
      errors[field.name] = "This field is required";
      isValid = false;
    }
  });

  if (!isValid) {
    setValidationErrors(errors);
    return;
  }

  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to update this language?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
   setLoading(true);
        const response = await axiosInstance.patch(
          `/language/update/${data.language_id}`,
          {
            business_partner_id: 1,
            language_name: formData.language,
            language_desc: formData.description,
            status: formData.status === "Active" ? 1 : 0,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`, // Authorization token
            },
          }
        );

        console.log("API Response:", response.data);

        Swal.fire({
          title: "Success",
          text: "Language updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate(ROUTES_NAVIGATION.LANGUAGELIST);
        });
      } catch (error) {
        console.error("Error submitting form:", error);

        const errorMessage = error.response?.data?.message;
        Swal.fire({
          title: "Error",
          text: errorMessage || "Failed to update language. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  });
};


  return (
    <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Language</span>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="form-container">
          <span className="cust-det-title mt-2 mb-2">
            Please Update Language Details
          </span>
          <DynamicForm
            formConfig={LanguageInputs}
            formData={formData}
            setFormData={setFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />
          <div className="btncontainer mt-3">
            <button onClick={handleFormSubmit} className="submit-btn">
              Update
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default EditLanguage;
